import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import { Auth0Provider } from '@auth0/auth0-react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { CssBaseline } from '@mui/material';




const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme({
  palette: {
    primary: {
      main: '#d00000',
    },
    error: {
      main: red.A400,
    },
    secondary: {
      main: 'rgb(155, 155, 155)',
    },
  },
});
const authDomain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const authClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

if (!authDomain || !authClientId) {
  console.warn(
    'Auth0 configuration missing: set REACT_APP_AUTH0_DOMAIN and REACT_APP_AUTH0_CLIENT_ID in your environment.'
  );
}
const onRedirectCallback = (appState) => {
  const returnTo = appState && appState.returnTo ? appState.returnTo : '/';

  const path = returnTo.startsWith('/') ? returnTo : `/${returnTo}`;

  try {
    window.history.replaceState(
      {},
      document.title,
      window.location.origin + window.location.pathname
    );


    window.location.replace(`#${path}`);
  } catch (e) {
    console.warn('Failed to navigate after redirect', e);
    window.location.hash = `#${path}`;
  }
};

const AppWithTheme = () => {
  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty('--mui-palette-primary-main', theme.palette.primary.main);
    root.style.setProperty('--mui-palette-warning-main', theme.palette.warning.main);
    root.style.setProperty('--mui-palette-secondary-main', theme.palette.secondary.main);
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  )
}

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={authDomain}
      clientId={authClientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AppWithTheme />
    </Auth0Provider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register();
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { type: 'module' });
  });
}

